var map = {
	"./apply.svg": "+H50",
	"./bg.png": "C34Q",
	"./big-screen/bg.png": "3k1G",
	"./big-screen/city-basic-left.png": "mZOT",
	"./big-screen/city-basic-right.png": "GDrh",
	"./big-screen/close-window.png": "u3oY",
	"./big-screen/dialog.png": "RfxH",
	"./big-screen/home-left-bg.png": "iL8O",
	"./big-screen/home-right-bg.png": "+bhf",
	"./big-screen/title.png": "TzGN",
	"./blue-judge.png": "Ir5W",
	"./card-edit-disabled.svg": "CtW7",
	"./card-edit.svg": "p2dP",
	"./config.svg": "LXUU",
	"./district-home/serviceSchool.png": "sG1o",
	"./district-home/serviceStudent.png": "FOtG",
	"./district-home/serviceTeacher.png": "BbPl",
	"./empty-image-default.png": "8DHg",
	"./favicon.png": "ZURh",
	"./green-judge.png": "V7gl",
	"./head-portrait/parents.png": "ALvc",
	"./head-portrait/student.png": "H6DB",
	"./head-portrait/teacher.png": "z/+U",
	"./head-portrait/urbandistrict.png": "wNbM",
	"./health.svg": "z1yF",
	"./high-report.png": "A/pC",
	"./high-standard.png": "wB/E",
	"./home.svg": "77/w",
	"./judge-file.svg": "oxTt",
	"./judge.svg": "YAYK",
	"./junior-report.png": "PGE6",
	"./junior-standard.png": "bskN",
	"./logo-left.png": "JR5y",
	"./operate.svg": "kK6s",
	"./persona.svg": "yfH8",
	"./primary-report.png": "mtmQ",
	"./primary-standard.png": "M2ce",
	"./purple-judge.png": "Ra5W",
	"./report.jpg": "H238",
	"./report.svg": "Myeu",
	"./student-home/assessment-report.png": "5lic",
	"./student-home/configure.png": "FVyl",
	"./student-home/quality-report.png": "PmMp",
	"./test.png": "2FlR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 32